import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import { useTranslation } from 'react-i18next';
import useTimeAgo from '../../../../../../../../../../../Hooks/useTimeAgo';
import useEnableDualChannel from '../../../../../../../../../../Hooks/useEnableDualChannel';
import { LatestDetection } from '../../../../../../../../../../LiveContext/SessionContext/SessionDetectionContextProvider/useSessionDetectionContext';
import StyledTypography from './styles';

function DetectionLine(props: { detection: LatestDetection & { cardTitle: string, commandTitle: string }, isHighlighted: boolean }) {
  const { detection, isHighlighted } = props;
  const timeAgo = useTimeAgo(detection.date);
  const { t } = useTranslation();
  const enableDualChannel = useEnableDualChannel();

  return (
    <StyledTypography key={detection.id} isHighlighted={isHighlighted} isFromClient={detection.isFromClient}>
      {enableDualChannel && <GraphicEqIcon titleAccess={detection.isFromClient ? t('detections.fromClient.tooltip') : t('detections.fromAgent.tooltip')} />}
      <strong>{detection.commandTitle}</strong>
      {t('detections.detected', { timeAgo })}
    </StyledTypography>
  );
}

export default DetectionLine;
